import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function TrustsPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas.trusts} />;
}
